import { MDBBadge, MDBIcon } from "mdbreact";
import React from "react";
import images from "../../../assets/img/app";
import classes from "./Stamp.module.scss";

/**
 * スタンププロパティ
 */
type StampProps = {
  /** スタンプID */
  id: string;
  /** スタンプ画像URL */
  image: string;
  /** 達成状態 */
  isAchieve: boolean;
  /** 確認済み状態 */
  isChecked: boolean;
  /** 取り外し可能か */
  isRemoveable?: boolean;
  /** ブランク状態か */
  isBlank: boolean;
  /** スタンプクリック時の処理 */
  onClick?: (id: string) => void;
  /** 取り外しのクリックイベント */
  onRemoveClick?: (id: string) => void;
};

/**
 * スタンプコンポーネント
 * @param props スタンププロパティ
 */
const Stamp: React.FC<StampProps> = (props) => {
  return (
    <div
      className={`text-center ${classes.stampContainer}`}
      onClick={() => (props.onClick ? props.onClick(props.id) : {})}
    >
      <img
        className={`${classes.stampImage} img-fluid ${
          props.isBlank ? classes.blankStamp : "z-depth-1"
        }${props.isAchieve ? ` ${classes.stampStatusAchieved}` : ""}`}
        src={props.image}
        alt=""
      />
      {props.isRemoveable ? (
        <MDBBadge
          pill
          color="light"
          className={`${classes.removeBadge} p-2`}
          onClick={() =>
            props.onRemoveClick ? props.onRemoveClick(props.id) : {}
          }
        >
          <MDBIcon icon="times" />
        </MDBBadge>
      ) : (
        ""
      )}
      {props.isAchieve ? (
        <img
          src={images.get}
          className={`${classes.getIcon}${
            props.isChecked ? "" : ` ${classes.animation}`
          }`}
          alt=""
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default Stamp;
